import * as React from "react";
import { FormikProps, Field } from "formik";
import { cx } from "@emotion/css";
import { FormValues } from "../../support/FormValues";
import bootstrapStyles from "../../css/bootstrap.module.css";
import formGroupStyles from "../../css/formgroup.module.css";
import { FieldNameEnum } from "../../support/FieldNameEnum";
import FieldRadioSelect from "../../components/FieldRadioSelect";
import { rothPortionOptions } from "../../support/rothPortionOptions";
import { AccountTypeEnum } from "../../support/AccountTypeEnum";
import FieldSelect from "../../components/FieldSelect";
import { RothPortionEnum } from "../../support/RothPortionEnum";
import PlainText from "../../components/PlainText";

interface OtherEmployerProps {
  formikBag: FormikProps<FormValues>;
}

const OtherEmployerNoneOptions = [
  AccountTypeEnum.TraditionalIRA,
  AccountTypeEnum.SEPIRA,
  AccountTypeEnum.SimpleIRA
];

const OtherEmployerSomeOptions = [AccountTypeEnum.TraditionalIRA];

const OtherEmployerAllOptions = [AccountTypeEnum.RothIRA];

export const OtherEmployer = ({
  formikBag: { values, setFieldValue }
}: OtherEmployerProps) => {
  const [otherEmployerOptions, setOtherEmployerOptions] = React.useState<
    AccountTypeEnum[]
  >([]);

  const setToAccountType = React.useCallback(
    (rothPortionWillSwitchTo: string) => {
      // get correct options for toAccountType and set default value
      switch (rothPortionWillSwitchTo) {
        case RothPortionEnum.all:
          setOtherEmployerOptions(OtherEmployerAllOptions);
          setFieldValue(FieldNameEnum.toAccountType, AccountTypeEnum.RothIRA);
          break;
        case RothPortionEnum.some:
          setOtherEmployerOptions(OtherEmployerSomeOptions);
          setFieldValue(
            FieldNameEnum.toAccountType,
            AccountTypeEnum.TraditionalIRA
          );
          break;
        case RothPortionEnum.none:
          setOtherEmployerOptions(OtherEmployerNoneOptions);
          if (
            otherEmployerOptions.length !== 0 &&
            !otherEmployerOptions.includes(values.toAccountType)
          ) {
            setFieldValue(
              FieldNameEnum.toAccountType,
              AccountTypeEnum.TraditionalIRA
            );
          }
          break;

        default:
          throw new Error("Check roth portion Option");
      }
    },
    [setFieldValue, values.toAccountType, otherEmployerOptions]
  );

  React.useEffect(() => {
    setToAccountType(values.rothPortion);
  }, [setToAccountType, values.rothPortion]);

  return (
    <React.Fragment>
      <div className={bootstrapStyles.row}>
        <div className={cx(bootstrapStyles["col-md-6"])}>
          <Field
            type="text"
            spellCheck="false"
            name={FieldNameEnum.rothPortion}
            label="What portion of this account is Roth money?"
            options={rothPortionOptions}
            component={FieldRadioSelect}
          />
        </div>
      </div>
      <div className={bootstrapStyles.row}>
        <div className={cx(bootstrapStyles["col-md-12"])}>
          <hr />
        </div>
      </div>

      <div className={bootstrapStyles.row}>
        <div className={cx(bootstrapStyles["col-md-6"])}>
          <Field
            name={FieldNameEnum.toAccountType}
            label={
              values.rothPortion === RothPortionEnum.some
                ? "Transfer Non-Roth Portion To"
                : "Transfer Account To"
            }
            options={otherEmployerOptions}
            component={FieldSelect}
            removeDefaultSelectOption
          />
        </div>
      </div>

      {values.rothPortion === RothPortionEnum.some && (
        <div className={bootstrapStyles.row}>
          <div className={cx(bootstrapStyles["col-md-6"])}>
            <PlainText
              id="transferNonRothPortion"
              label="Transfer Roth Portion To"
              text="Roth IRA"
            />
          </div>
        </div>
      )}

      <div className={cx(bootstrapStyles.row)}>
        <div className={cx(bootstrapStyles["col-md-6"])}>
          {values.toAccountType === AccountTypeEnum.SimpleIRA && (
            <div className={formGroupStyles["form-group"]}>
              <em>
                If this account does not meet the 2-yr contribution rule we will
                open a Traditional IRA on your behalf to receive this transfer.
              </em>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
